import { render, staticRenderFns } from "./view-recruitment-form.vue?vue&type=template&id=77716f5e&scoped=true"
import script from "./view-recruitment-form.vue?vue&type=script&lang=js"
export * from "./view-recruitment-form.vue?vue&type=script&lang=js"
import style0 from "./view-recruitment-form.vue?vue&type=style&index=0&id=77716f5e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77716f5e",
  null
  
)

export default component.exports